import React, { Component } from 'react';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';

import styles from './index.module.scss';

interface IProps extends Omit<InputProps, 'status'> {
  error?: boolean;
}

export class SxInput extends Component<IProps> {
  render(): JSX.Element {
    const {
      placeholder,
      ...remainingProps
    } = this.props;

    const placeholderValue = placeholder ?? 'Write here';

    return (<div className={styles.inputStyle}>
      <Input
        placeholder={placeholderValue}
        {...remainingProps}
      />
    </div>);
  }
}
